// Modified https://coolcssanimation.com/how-to-trigger-a-css-animation-on-scroll/
function scrollSpy(selector, animationClass, delay) {
  //need to add class="scroll-anim" to animated scroll element(s)
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (delay !== undefined) {
            setTimeout(function () {
              entry.target.classList.add(animationClass);
            }, delay);
          } else {
            entry.target.classList.add(animationClass);
          }
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '-50px' }
  ); //the offset when animation triggers

  document.querySelectorAll(selector).forEach((el) => observer.observe(el));
}
